import { render, staticRenderFns } from "./CommonComponent.vue?vue&type=template&id=1e340880&scoped=true"
import script from "./CommonComponent.vue?vue&type=script&lang=js"
export * from "./CommonComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonComponent.vue?vue&type=style&index=0&id=1e340880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e340880",
  null
  
)

export default component.exports